var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVelocitySprint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 18.75C12.4069 18.75 13.75 17.4069 13.75 15.75C13.75 14.0931 12.4069 12.75 10.75 12.75C9.09315 12.75 7.75 14.0931 7.75 15.75C7.75 17.4069 9.09315 18.75 10.75 18.75Z",
    stroke: "#082B72",
    strokeOpacity: 0.69,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 12.75V7.75M20.75 10.75C20.75 5.227 16.273 0.75 10.75 0.75C5.227 0.75 0.75 5.227 0.75 10.75",
    stroke: "#082B72",
    strokeOpacity: 0.69,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelocitySprint);
export default __webpack_public_path__ + "static/media/velocity_sprint.226fd1bbf2b92ecc4a77df1f69732976.svg";
export { ForwardRef as ReactComponent };